import { useState, useRef, useEffect, useMemo } from 'react'
import Layout from '../components/common/Layout'
import NewShell from '../components/pages-new/NewShell'
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Link as MuiLink,
  FormControlLabel,
  Checkbox,
  Card,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import ButtonSp from '../components/ui/ButtonSp'
import DividerWithText from '../components/ui/DividerWithText'
import useStyles from '../components/common/loginRegStyle'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import clsx from 'clsx'
import { useForm } from 'react-hook-form'
import Axios from 'axios'
import useSnackBar from '../components/ui/useSnackBar'
import getConfig from 'next/config'
import ReCAPTCHA from 'react-google-recaptcha'
import ProtectedByRecaptcha from '../components/common/ProtectedByRecaptcha'

import Link from '../components/utility/CustomLink'
import { useRouter } from 'next/router'
import { getCookie, setCookie, removeCookie } from '../utils/cookies'

import regNew from '../components/pages-new/RegisterNew.module.scss'
const { publicRuntimeConfig } = getConfig()

const REF_CODE_COOKIE_NAME = 'FQeqqBVeJD'
const MKT_ID_COOKIE_NAME = 'hVItowGTjY'

const ONE_DAY_IN_SECOND = 86400

const RegisterContainer = ({ previousPath, t, isNew }) => {
  const [isPassedRecapcha, setIsPassRecapcha] = useState(false)
  const [isShowingPassword, setShowingPassword] = useState(false)
  const [isTicked, setTicked] = useState(false)

  const [consentAnalytic, setConsentAnalytic] = useState(false)
  const [consentService, setConsentService] = useState(false)
  const [consentMarketing, setConsentMarketing] = useState(false)

  const [consentInformation, setConsentInformation] = useState(true)
  const [consentPersonalData, setConsentPersonalData] = useState(true)
  const [consentGroupCompany, setConsentGroupCompany] = useState({
    easyPost: true,
    easyOrder: true,
    shippop: true,
    shippopNext: true,
    mySave: true,
    tqm: true
  })

  const [isShowingConfirmEmail, setShowingConfirmEmail] = useState(false)
  const classes = useStyles()
  const { register, handleSubmit, errors } = useForm()

  const theme = useTheme()
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { displaySnackBar, renderSnackBar } = useSnackBar()

  const [isRecaptchaExecuting, setRecaptchaExecuting] = useState(false)
  const recaptchaRef = useRef(null)

  const consentCompanyGroupChecked = useMemo(() => {
    return Object.values(consentGroupCompany).some((val) => val)
  }, [consentGroupCompany])

  const Router = useRouter()

  const { locale } = Router
  const language = locale

  const handleChangeMainConsentCompanyGroup = () => {
    setConsentGroupCompany({
      easyPost: !consentCompanyGroupChecked,
      easyOrder: !consentCompanyGroupChecked,
      shippop: !consentCompanyGroupChecked,
      shippopNext: !consentCompanyGroupChecked,
      mySave: !consentCompanyGroupChecked,
      tqm: !consentCompanyGroupChecked
    })
  }

  const handlerFacebookLogin = (e, url, refCode, mktId) => {
    e.preventDefault()
    if (refCode) {
      removeCookie(REF_CODE_COOKIE_NAME)
    }
    if (mktId) {
      removeCookie(MKT_ID_COOKIE_NAME)
    }
    window.location.href = url
  }

  const renderFbGgLogin = () => {
    const refCode = getCookie(REF_CODE_COOKIE_NAME)
    const mktId = getCookie(MKT_ID_COOKIE_NAME)

    const fbRefCode = refCode ? `&refCode=${refCode}` : ``
    const fbMktId = mktId ? `&mktId=${mktId}` : ``

    const cbUrl = encodeURIComponent(
      `${publicRuntimeConfig.siteDomain}/verify?destUrl=${previousPath}`
    )
    const url = `${publicRuntimeConfig.memberService}/sso/login/facebook?isIframe=false&needSSOToken=true${fbRefCode}${fbMktId}&cbUrl=${cbUrl}`
    return (
      <Grid container className={classes.socialLogin}>
        <Grid
          item
          xs={12}
          sm={12}
          className={clsx(
            classes.padding1,
            isTabletOrMobile && classes.noPaddingX
          )}
        >
          <a
            href={`#`}
            onClick={(e) => handlerFacebookLogin(e, url, refCode, mktId)}
          >
            <ButtonSp variant="outlined" className={classes.loginBtn} fullWidth>
              <img
                src="/static/img/login-register/fb-icon.svg"
                className={classes.marginRight1}
              />
              {t('login-with')} Facebook
            </ButtonSp>
          </a>
        </Grid>
      </Grid>
    )
  }

  // Builds the same Facebook SSO url as renderFbGgLogin (refCode/mktId cookies
  // included). Used by the ?new-design FB button so it shares the old wiring
  // without touching renderFbGgLogin.
  const getFacebookUrl = () => {
    const refCode = getCookie(REF_CODE_COOKIE_NAME)
    const mktId = getCookie(MKT_ID_COOKIE_NAME)
    const fbRefCode = refCode ? `&refCode=${refCode}` : ``
    const fbMktId = mktId ? `&mktId=${mktId}` : ``
    const cbUrl = encodeURIComponent(
      `${publicRuntimeConfig.siteDomain}/verify?destUrl=${previousPath}`
    )
    return `${publicRuntimeConfig.memberService}/sso/login/facebook?isIframe=false&needSSOToken=true${fbRefCode}${fbMktId}&cbUrl=${cbUrl}`
  }

  const onFormSubmit = handleSubmit(async (data) => {
    if (!isTicked) {
      alert(t('error.please-accept'))
      return
    }

    try {
      setRecaptchaExecuting(true)

      let realCaptchaSuccess = isPassedRecapcha
      if (!isPassedRecapcha) {
        const token = await recaptchaRef.current.executeAsync()
        const {
          data: { success: captchaSuccess },
        } = await Axios.post('/api/recaptcha/validate', {
          recaptchaToken: token,
        })
        realCaptchaSuccess = captchaSuccess
        if (realCaptchaSuccess) {
          setIsPassRecapcha(() => true)
        }
      }

      if (realCaptchaSuccess) {
        const newData = {
          ...data,
          // consentAnalytic,
          // consentService,
          // consentMarketing,
          consentInformation,
          consentPersonalData,
          consentCompanyGroup: consentCompanyGroupChecked,
          consentGroupCompanyEasyPost: consentGroupCompany.easyPost,
          consentGroupCompanyEasyOrder: consentGroupCompany.easyOrder,
          consentGroupCompanyShippop: consentGroupCompany.shippop,
          consentGroupCompanyShippopNext: consentGroupCompany.shippopNext,
          consentGroupCompanyMySave: consentGroupCompany.mySave,
          consentGroupCompanyTqm: consentGroupCompany.tqm 
        }

        const refCode = getCookie(REF_CODE_COOKIE_NAME)
        const mktId = getCookie(MKT_ID_COOKIE_NAME)
        if (refCode) {
          newData.refCode = refCode
        }
        if (mktId) {
          newData.mktId = mktId
        }

        const res = await Axios.post('/api/auth/register', newData)
        if (res.data.status === 'success') {
          // // ------- ลบ cookies --------------------------
          if (refCode) {
            removeCookie(REF_CODE_COOKIE_NAME)
          }
          if (mktId) {
            removeCookie(MKT_ID_COOKIE_NAME)
          }
          // // ---------------------------------------------
          setShowingConfirmEmail(true)
        } else {
          displaySnackBar('error', t('error.unknown'))
        }
      } else {
        displaySnackBar('error', 'Captcha validation failed')
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        if (err.response.data.message === 'email_taken') {
          // show email taken error
          displaySnackBar('error', t('error.email-taken'))
          return
        }
        if (err.response.data.message === 'phone_taken') {
          // show phone taken error
          displaySnackBar('error', t('error.phone-taken'))
          return
        }
      }
      // show unknown error
      displaySnackBar('error', t('error.unknown'))
      return
    } finally {
      setRecaptchaExecuting(false)
    }
  })

  const renderBtnsSection = () => {
    return (
      <div className={classes.btnsSection}>
        {renderFbGgLogin()}
        <DividerWithText width="100%">{t('or')}</DividerWithText>
        <form className={classes.inputsSection} onSubmit={onFormSubmit}>
          <TextField
            label={t('name')}
            name="name"
            variant="outlined"
            margin="normal"
            fullWidth
            inputRef={register({ required: true })}
            error={errors.name}
            helperText={errors.name && t('error.please-fill-name')}
            placeholder={t('name-p')}
          />
          <TextField
            label={t('phone')}
            name="phone"
            variant="outlined"
            margin="normal"
            fullWidth
            inputRef={register({ required: true, pattern: /^0\d{8,9}$/ })}
            error={errors.phone}
            helperText={errors.phone && t('error.please-fill-phone-correctly')}
            placeholder={t('phone-p')}
          />
          <TextField
            label={t('email')}
            name="email"
            variant="outlined"
            margin="normal"
            fullWidth
            inputRef={register({
              required: true,
              // pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
              pattern: /^[\w\-\.]+(\+[\w\-\.]+)?@([\w\-]+\.)+[\w-]{2,4}$/,
            })}
            error={errors.email}
            helperText={errors.email && t('error.please-fill-email-correctly')}
            placeholder={t('email-p')}
          />
          <TextField
            label={t('password')}
            name="password"
            variant="outlined"
            margin="normal"
            fullWidth
            type={isShowingPassword ? 'text' : 'password'}
            helperText={t('password-helper')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowingPassword(!isShowingPassword)}
                  >
                    {isShowingPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputRef={register({
              required: true,
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
            })}
            error={errors.password}
            placeholder={t('password-p')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isTicked}
                onChange={() => setTicked(!isTicked)}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('by-signing-up')}{' '}
                <Link href={withNew('/privacy')} passHref>
                  <MuiLink>{t('policy')}</MuiLink>
                </Link>{' '}
                {t('and-our')}{' '}
                <Link href={withNew('/terms')} passHref>
                  <MuiLink>{t('terms-of-service')}</MuiLink>
                </Link>
              </p>
            }
          />

          {/* <FormControlLabel
            control={
              <Checkbox
                checked={consentAnalytic}
                onChange={() => setConsentAnalytic(!consentAnalytic)}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('consent_analytic')}{' '}
              </p>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={consentService}
                onChange={() => setConsentService(!consentService)}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('consent_service')}{' '}
              </p>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={consentMarketing}
                onChange={() => setConsentMarketing(!consentMarketing)}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('consent_marketing')}{' '}
              </p>
            }
          /> */}

          <FormControlLabel
            control={
              <Checkbox
                checked={consentInformation}
                onChange={() => setConsentInformation(!consentInformation)}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('consent_information')}
              </p>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={consentPersonalData}
                onChange={() => setConsentPersonalData(!consentPersonalData)}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('consent_personal_data')}
              </p>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={consentCompanyGroupChecked}
                onChange={handleChangeMainConsentCompanyGroup}
                name="acceptCheckbox"
                color="primary"
              />
            }
            label={
              <p className={classes.termsPrivacyText}>
                {t('consent_group_company')}
              </p>
            }
          />

          {consentCompanyGroupChecked && (
            <div className={classes.consentGroupCompanyContainer}>
              <p className={classes.textConsentRemarkStar}>*** {t('consent_group_company_remark_1')}</p>
              <p className={classes.textConsentRemark}>{t('consent_group_company_remark_2')}</p>
              <p className={classes.textConsentRemark}>{t('consent_group_company_remark_3')}</p>
              <p className={classes.textConsentRemarkTitle}>{t('consent_group_company_remark_4')}</p>
              <p className={classes.textConsentRemark}>{t('consent_group_company_remark_5')}</p>
              <p className={classes.textConsentRemarkUnderline}>{t('consent_group_company_remark_6')}</p>
              <ul style={{ margin: 0 }}>
                <li>{t('consent_group_company_remark_7')}</li>
                <li>{t('consent_group_company_remark_8')}</li>
              </ul>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentGroupCompany.easyPost}
                    onChange={() => setConsentGroupCompany((prev) => ({ ...prev, easyPost: !prev.easyPost }))}
                    name="acceptCheckbox"
                    color="primary"
                  />
                }
                label={
                  <p className={classes.termsPrivacyText} style={{ margin: 0 }}>
                    {t('consent_group_company_easypost')}
                  </p>
                }
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentGroupCompany.easyOrder}
                    onChange={() => setConsentGroupCompany((prev) => ({ ...prev, easyOrder: !prev.easyOrder }))}
                    name="acceptCheckbox"
                    color="primary"
                  />
                }
                label={
                  <p className={classes.termsPrivacyText} style={{ margin: 0 }}>
                    {t('consent_group_company_easyorder')}
                  </p>
                }
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentGroupCompany.shippop}
                    onChange={() => setConsentGroupCompany((prev) => ({ ...prev, shippop: !prev.shippop }))}
                    name="acceptCheckbox"
                    color="primary"
                  />
                }
                label={
                  <p className={classes.termsPrivacyText} style={{ margin: 0 }}>
                    {t('consent_group_company_shippop')}
                  </p>
                }
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentGroupCompany.shippopNext}
                    onChange={() => setConsentGroupCompany((prev) => ({ ...prev, shippopNext: !prev.shippopNext }))}
                    name="acceptCheckbox"
                    color="primary"
                  />
                }
                label={
                  <p className={classes.termsPrivacyText} style={{ margin: 0 }}>
                    {t('consent_group_company_shippop_next')}
                  </p>
                }
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentGroupCompany.mySave}
                    onChange={() => setConsentGroupCompany((prev) => ({ ...prev, mySave: !prev.mySave }))}
                    name="acceptCheckbox"
                    color="primary"
                  />
                }
                label={
                  <p className={classes.termsPrivacyText} style={{ margin: 0 }}>
                    {t('consent_group_company_mysave')}
                  </p>
                }
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentGroupCompany.tqm}
                    onChange={() => setConsentGroupCompany((prev) => ({ ...prev, tqm: !prev.tqm }))}
                    name="acceptCheckbox"
                    color="primary"
                  />
                }
                label={
                  <p className={classes.termsPrivacyText} style={{ margin: 0 }}>
                    {t('consent_groip_company_tqm')}
                  </p>
                }
              />
            </div>
          )}

          {/* <div className={classes.forgotLoginFiller} /> */}
          {/* hidden lang input */}
          <input
            hidden
            name="lang"
            value={language.toUpperCase()}
            ref={register}
            readOnly
          />
          <ReCAPTCHA
            size="invisible"
            sitekey={publicRuntimeConfig.recaptcha2Key}
            ref={recaptchaRef}
            style={{
              zIndex: 999,
            }}
            badge="bottomleft"
          />
          <p className={classes.toRegister}>
            <ProtectedByRecaptcha />
          </p>
          <ButtonSp
            className={classes.loginBtn}
            type="submit"
            loading={isRecaptchaExecuting}
          >
            {t('signup')}
          </ButtonSp>
          <p className={classes.toRegister}>
            {t('if-already-member')}{' '}
            <Link href={withNew('/login')} passHref>
              <MuiLink>{t('login')}</MuiLink>
            </Link>
          </p>
        </form>
      </div>
    )
  }

  const renderConfirmEmailCard = () => {
    return (
      <Card className={classes.confirmEmailCard}>
        <dl className={clsx(classes.confirmEmailText1, classes.colorPrimary)}>
          <MailOutlineIcon
            fontSize="large"
            style={{ verticalAlign: 'bottom', marginRight: 8 }}
          />{' '}
          {t('please-confirm-email')}
        </dl>
        <dl className={classes.confirmEmailText2}>{t('check-junk-mail')}</dl>
      </Card>
    )
  }

  useEffect(() => {
    const { query } = Router
    const { refCode = '', mktId = '' } = query

    //  // ------- about refCode -----------------------------------
    const currentRefCodeCookies = getCookie(REF_CODE_COOKIE_NAME)

    if (!currentRefCodeCookies) {
      if (refCode) {
        console.info('ส่ง refCode มาจาก query params => set new cookies')
        setCookie(REF_CODE_COOKIE_NAME, refCode, { maxAge: ONE_DAY_IN_SECOND })
      }
    } else {
      if (refCode && refCode !== currentRefCodeCookies) {
        setCookie(REF_CODE_COOKIE_NAME, refCode, { maxAge: ONE_DAY_IN_SECOND })
      }
    }
    // // --------------------------------------------------------------
    // // ----------- about mktId --------------------------------------
    const currentMktIdCookies = getCookie(MKT_ID_COOKIE_NAME)

    if (!currentMktIdCookies) {
      if (mktId) {
        setCookie(MKT_ID_COOKIE_NAME, mktId, { maxAge: ONE_DAY_IN_SECOND })
      }
    } else {
      if (mktId && mktId !== currentMktIdCookies) {
        setCookie(MKT_ID_COOKIE_NAME, mktId, { maxAge: ONE_DAY_IN_SECOND })
      }
    }

    // // --------------------------------------------------------------
  }, [])

  // // ----------- for debuging ----------------
  // console.info(
  //   'publicRuntimeConfig.recaptcha2Key',
  //   publicRuntimeConfig.recaptcha2Key
  // )
  // // -----------------------------------------

  // Keep internal nav in the same chrome: append ?old only in the old design.
  const withNew = (path) => (isNew ? path : `${path}?old`)

  const META = {
    title: 'สมัครสมาชิก - SHIPPOP ทำเรื่องจัดส่งพัสดุให้เป็นเรื่องง่าย',
    keywords: 'ส่งพัสดุ, ส่งของ, เช็คค่าส่ง, เช็คราคา, เช็คพัสดุ',
    description:
      'เปรียบเทียบราคาการส่งของ เช็คราคา เช็คค่าส่ง บริการขนส่ง ส่งพัสดุ จองขนส่งและจ่ายเงินออนไลน์ ปริ้น แปะ ส่ง รอคนมารับของถึงหน้าบ้าน',
  }

  // CONTENT identical for both variants; only the chrome differs.
  const content = (
          <Grid container className={classes.page}>
            {!isTabletOrMobile && (
              <Grid item xs={12} md={5}>
                <img
                  src="/static/img/login-register/register.jpg"
                  alt="login cover"
                  className={classes.coverImg}
                />
              </Grid>
            )}
            <Grid
              item
              container
              xs={12}
              md={7}
              direction="column"
              alignItems="center"
              justify="flex-start"
              className={classes.innerRightSection}
            >
              <h1>{t('signup-shippop')}</h1>
              <h2>{t('make-shipping-easy')}</h2>
              {isShowingConfirmEmail
                ? renderConfirmEmailCard()
                : renderBtnsSection()}
            </Grid>
          </Grid>
  )

  // ?new-design register (matches the register mockup): a FULL-BLEED cover
  // photo as the page background with a single white form card floating on the
  // RIGHT over it (NOT a contained 2-panel card). It REUSES the exact same form
  // wiring as the old form: react-hook-form register() refs + validation,
  // onFormSubmit (recaptcha + isTicked gate + refCode/mktId cookies), every
  // consent checkbox handler/state, the invisible ReCAPTCHA, and withNew() for
  // the privacy/terms/login links. Only the OUTER MARKUP/classes change to the
  // RegisterNew.module.scss full-bleed layout. The old (no-?new) rendering
  // above is untouched.
  const newContent = (
    <div className={regNew.page}>
      {/* Full-bleed cover photo as the page background (left-anchored,
          object-fit:cover). Runs edge-to-edge and up behind NewShell's
          floating toolbar. cover.png/.webp live in register-new/ so the file
          can be swapped for the real warehouse photo with no code change. */}
      <picture>
        <source srcSet="/static/img/register-new/cover.webp" type="image/webp" />
        <img
          className={regNew.bg}
          src="/static/img/register-new/cover.png"
          alt={t('signup-cover-alt')}
          loading="lazy"
          decoding="async"
        />
      </picture>
      <div className={regNew.wash} aria-hidden="true" />

      <div className={regNew.right}>
          {isShowingConfirmEmail ? (
            <div className={regNew.confirmCard}>
              <MailOutlineIcon className={regNew.confirmIcon} fontSize="large" />
              <p className={regNew.confirmTitle}>{t('please-confirm-email')}</p>
              <p className={regNew.confirmText}>{t('check-junk-mail')}</p>
            </div>
          ) : (
            <>
              <h1 className={regNew.rightHeading}>
                {t('signup')} <span>SHIPPOP</span>
              </h1>
              <p className={regNew.rightSub}>{t('signup-subtitle')}</p>

              <form onSubmit={onFormSubmit}>
                <div className={regNew.field}>
                  <label className={regNew.label} htmlFor="reg-new-name">
                    {t('name')}
                  </label>
                  <div className={regNew.inputWrap}>
                    <input
                      id="reg-new-name"
                      name="name"
                      type="text"
                      className={clsx(
                        regNew.input,
                        errors.name && regNew.inputError
                      )}
                      placeholder={t('name-p')}
                      ref={register({ required: true })}
                    />
                  </div>
                  {errors.name && (
                    <p className={regNew.errorText}>
                      {t('error.please-fill-name')}
                    </p>
                  )}
                </div>

                <div className={regNew.field}>
                  <label className={regNew.label} htmlFor="reg-new-phone">
                    {t('phone')}
                  </label>
                  <div className={regNew.inputWrap}>
                    <input
                      id="reg-new-phone"
                      name="phone"
                      type="tel"
                      className={clsx(
                        regNew.input,
                        errors.phone && regNew.inputError
                      )}
                      placeholder={t('phone-p')}
                      ref={register({ required: true, pattern: /^0\d{8,9}$/ })}
                    />
                  </div>
                  {errors.phone && (
                    <p className={regNew.errorText}>
                      {t('error.please-fill-phone-correctly')}
                    </p>
                  )}
                </div>

                <div className={regNew.field}>
                  <label className={regNew.label} htmlFor="reg-new-email">
                    {t('email')}
                  </label>
                  <div className={regNew.inputWrap}>
                    <input
                      id="reg-new-email"
                      name="email"
                      type="email"
                      className={clsx(
                        regNew.input,
                        errors.email && regNew.inputError
                      )}
                      placeholder={t('email-p')}
                      ref={register({
                        required: true,
                        pattern: /^[\w\-\.]+(\+[\w\-\.]+)?@([\w\-]+\.)+[\w-]{2,4}$/,
                      })}
                    />
                  </div>
                  {errors.email && (
                    <p className={regNew.errorText}>
                      {t('error.please-fill-email-correctly')}
                    </p>
                  )}
                </div>

                <div className={regNew.field}>
                  <label className={regNew.label} htmlFor="reg-new-password">
                    {t('password')}
                  </label>
                  <div className={regNew.inputWrap}>
                    <input
                      id="reg-new-password"
                      name="password"
                      type={isShowingPassword ? 'text' : 'password'}
                      className={clsx(
                        regNew.input,
                        errors.password && regNew.inputError
                      )}
                      placeholder={t('password-p')}
                      ref={register({
                        required: true,
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                      })}
                    />
                    <button
                      type="button"
                      className={regNew.eyeBtn}
                      onClick={() => setShowingPassword(!isShowingPassword)}
                      aria-label={t('password')}
                    >
                      {isShowingPassword ? <VisibilityOff /> : <Visibility />}
                    </button>
                  </div>
                  <p className={regNew.hint}>{t('password-helper')}</p>
                </div>

                {/* PDPA consent block — same checkboxes/handlers/state as the
                    old form, restyled for the new card. */}
                <div className={regNew.consent}>
                  <FormControlLabel
                    style={{ alignItems: 'flex-start', marginRight: 0 }}
                    control={
                      <Checkbox
                        checked={isTicked}
                        onChange={() => setTicked(!isTicked)}
                        name="acceptCheckbox"
                        color="primary"
                      />
                    }
                    label={
                      <p className={regNew.consentText}>
                        {t('by-signing-up')}{' '}
                        <Link href={withNew('/privacy')} passHref>
                          <MuiLink>{t('policy')}</MuiLink>
                        </Link>{' '}
                        {t('and-our')}{' '}
                        <Link href={withNew('/terms')} passHref>
                          <MuiLink>{t('terms-of-service')}</MuiLink>
                        </Link>
                      </p>
                    }
                  />

                  <FormControlLabel
                    style={{ alignItems: 'flex-start', marginRight: 0 }}
                    control={
                      <Checkbox
                        checked={consentInformation}
                        onChange={() =>
                          setConsentInformation(!consentInformation)
                        }
                        name="acceptCheckbox"
                        color="primary"
                      />
                    }
                    label={
                      <p className={regNew.consentText}>
                        {t('consent_information')}
                      </p>
                    }
                  />

                  <FormControlLabel
                    style={{ alignItems: 'flex-start', marginRight: 0 }}
                    control={
                      <Checkbox
                        checked={consentPersonalData}
                        onChange={() =>
                          setConsentPersonalData(!consentPersonalData)
                        }
                        name="acceptCheckbox"
                        color="primary"
                      />
                    }
                    label={
                      <p className={regNew.consentText}>
                        {t('consent_personal_data')}
                      </p>
                    }
                  />

                  <FormControlLabel
                    style={{ alignItems: 'flex-start', marginRight: 0 }}
                    control={
                      <Checkbox
                        checked={consentCompanyGroupChecked}
                        onChange={handleChangeMainConsentCompanyGroup}
                        name="acceptCheckbox"
                        color="primary"
                      />
                    }
                    label={
                      <p className={regNew.consentText}>
                        {t('consent_group_company')}
                      </p>
                    }
                  />

                  {consentCompanyGroupChecked && (
                    <>
                      <div className={regNew.remarkBox}>
                        <p className={regNew.remarkStar}>
                          *** {t('consent_group_company_remark_1')}
                        </p>
                        <p className={regNew.remarkText}>
                          {t('consent_group_company_remark_2')}
                        </p>
                        <p className={regNew.remarkText}>
                          {t('consent_group_company_remark_3')}
                        </p>
                      </div>

                      <p className={regNew.remarkTitle}>
                        {t('consent_group_company_remark_4')}
                      </p>
                      <p className={regNew.remarkText}>
                        {t('consent_group_company_remark_5')}
                      </p>
                      <p className={regNew.remarkUnderline}>
                        {t('consent_group_company_remark_6')}
                      </p>
                      <ul className={regNew.partnerBullets}>
                        <li>{t('consent_group_company_remark_7')}</li>
                        <li>{t('consent_group_company_remark_8')}</li>
                      </ul>

                      <div className={regNew.partnerGrid}>
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          control={
                            <Checkbox
                              checked={consentGroupCompany.easyPost}
                              onChange={() =>
                                setConsentGroupCompany((prev) => ({
                                  ...prev,
                                  easyPost: !prev.easyPost,
                                }))
                              }
                              name="acceptCheckbox"
                              color="primary"
                            />
                          }
                          label={
                            <p className={regNew.partnerText}>
                              {t('consent_group_company_easypost')}
                            </p>
                          }
                        />
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          control={
                            <Checkbox
                              checked={consentGroupCompany.easyOrder}
                              onChange={() =>
                                setConsentGroupCompany((prev) => ({
                                  ...prev,
                                  easyOrder: !prev.easyOrder,
                                }))
                              }
                              name="acceptCheckbox"
                              color="primary"
                            />
                          }
                          label={
                            <p className={regNew.partnerText}>
                              {t('consent_group_company_easyorder')}
                            </p>
                          }
                        />
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          control={
                            <Checkbox
                              checked={consentGroupCompany.shippop}
                              onChange={() =>
                                setConsentGroupCompany((prev) => ({
                                  ...prev,
                                  shippop: !prev.shippop,
                                }))
                              }
                              name="acceptCheckbox"
                              color="primary"
                            />
                          }
                          label={
                            <p className={regNew.partnerText}>
                              {t('consent_group_company_shippop')}
                            </p>
                          }
                        />
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          control={
                            <Checkbox
                              checked={consentGroupCompany.shippopNext}
                              onChange={() =>
                                setConsentGroupCompany((prev) => ({
                                  ...prev,
                                  shippopNext: !prev.shippopNext,
                                }))
                              }
                              name="acceptCheckbox"
                              color="primary"
                            />
                          }
                          label={
                            <p className={regNew.partnerText}>
                              {t('consent_group_company_shippop_next')}
                            </p>
                          }
                        />
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          control={
                            <Checkbox
                              checked={consentGroupCompany.mySave}
                              onChange={() =>
                                setConsentGroupCompany((prev) => ({
                                  ...prev,
                                  mySave: !prev.mySave,
                                }))
                              }
                              name="acceptCheckbox"
                              color="primary"
                            />
                          }
                          label={
                            <p className={regNew.partnerText}>
                              {t('consent_group_company_mysave')}
                            </p>
                          }
                        />
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          control={
                            <Checkbox
                              checked={consentGroupCompany.tqm}
                              onChange={() =>
                                setConsentGroupCompany((prev) => ({
                                  ...prev,
                                  tqm: !prev.tqm,
                                }))
                              }
                              name="acceptCheckbox"
                              color="primary"
                            />
                          }
                          label={
                            <p className={regNew.partnerText}>
                              {t('consent_groip_company_tqm')}
                            </p>
                          }
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* hidden lang input */}
                <input
                  hidden
                  name="lang"
                  value={language.toUpperCase()}
                  ref={register}
                  readOnly
                />
                <ReCAPTCHA
                  size="invisible"
                  sitekey={publicRuntimeConfig.recaptcha2Key}
                  ref={recaptchaRef}
                  style={{ zIndex: 999 }}
                  badge="bottomleft"
                />
                <p className={regNew.recaptchaNote}>
                  <ProtectedByRecaptcha />
                </p>

                <button
                  type="submit"
                  className={regNew.submit}
                  disabled={isRecaptchaExecuting}
                >
                  {t('signup')}
                </button>

                <p className={regNew.footLinks}>
                  {t('if-already-member')}{' '}
                  <Link href={withNew('/login')} passHref>
                    <MuiLink>{t('login')}</MuiLink>
                  </Link>
                </p>
              </form>
            </>
          )}
      </div>
    </div>
  )

  // ?new: new-design chrome (NewShell already provides Layout + HeaderNew +
  // FooterNew, so it is NOT nested inside the old Layout). Renders the new
  // 2-panel card; the old `content` is kept for the default (no-?new) path.
  if (isNew) {
    return (
      <>
        <NewShell {...META}>{newContent}</NewShell>
        {renderSnackBar()}
      </>
    )
  }

  // Default (no ?new): original chrome, unchanged.
  return (
    <>
      <div className={classes.root}>
        <Layout noFooter noFloatingButtons {...META}>
          {content}
        </Layout>
      </div>
      {renderSnackBar()}
    </>
  )
}

export default RegisterContainer
